import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { BsTelephoneForwardFill, BsFillPhoneFill } from "react-icons/bs";
import Bread from "../../common/Bread";
import { MdEmail } from "react-icons/md";
import "./style.scss";
import { LangContext } from "../../context/LangContext";

const Officers = () => {
  const { slug } = useParams();

  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const [title, setTitle] = useState("");
  const [Data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setDynamicTitle();
    getSampleApiData();
  }, [slug, nep]);

  const setDynamicTitle = () => {
    switch (slug) {
      case "amit-shrestha":
        setTitle(nep ? "गुनासो अधिकारी" : "Grievance Officers");
        break;

      case "sanjaya-thapaliya1716534771":
        setTitle(nep ? "सूचना अधिकारी" : "Information Officers");
        break;

      case "suraj-timalsina1716706768":
        setTitle(nep ? "अनुपालन अधिकारी" : "Compliance Officers");
        break;

      default:
        setTitle(nep ? "अधिकारीहरू" : "Officers");
    }
  };

  async function getSampleApiData() {
    try {
      const response = await axios(
        `https://admin.icfcbank.com/api/officers/officer/${slug}`,
      );

      const detail = response.data.detail;

      setData(detail);
    } catch (error) {
      setError(error);
    }

    setLoading(false);
  }

  const breadcrumList = {
    image: "",
    title: title,
    l1: nep ? "होम" : "Home",
    l2: nep ? "अधिकारीहरू" : "Officers",
    l3: "",
  };

  if (loading) return "...";
  if (error) return "Error!";

  return (
    <Bread data={breadcrumList}>
      <div className="officerss">
        <div className="branch"></div>

        <div className="paper">
          <div className="detail-container">
            <img src={Data?.featured_image} alt={Data?.slug} />

            <p className="officer-name">
              {nep ? Data?.name_nepali : Data?.name}
            </p>

            <div>
              <MdEmail />
              <p>{Data?.email}</p>
            </div>

            <div>
              <BsTelephoneForwardFill />
              <p>{Data?.contact}</p>
            </div>

            <div>
              <BsFillPhoneFill />
              <p>{Data?.mobile}</p>
            </div>
          </div>
        </div>
      </div>
    </Bread>
  );
};

export default Officers;
